import React from 'react'

import CantileverButton from './CantileverButton'
import { Popup } from './Popup'

interface ConfirmDeletePopupProps {
  entityName: string
  popupPosition: { top: number; left: number }
  cancelDelete: () => void
  confirmDelete: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  deleteMessage?: string
}

export const ConfirmDeletePopup: React.FC<ConfirmDeletePopupProps> = ({
  entityName,
  popupPosition,
  deleteMessage,
  cancelDelete,
  confirmDelete,
}) => {
  const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node | null)) {
      cancelDelete()
    }
  }

  return (
    <Popup
      position={popupPosition}
      onBlur={handleBlur}
      message={deleteMessage ?? `Delete this ${entityName}?`}
      actions={
        <>
          <CantileverButton
            aria-label='Confirm Delete'
            autoFocus
            danger
            onClick={confirmDelete}>
            Delete
          </CantileverButton>
          <CantileverButton aria-label='Cancel Delete' onClick={cancelDelete}>
            Cancel
          </CantileverButton>
        </>
      }
    />
  )
}
